import { HttpClient } from '@angular/common/http';
import { Type } from '@angular/core';
import { trim } from 'lodash';
import { Subject } from 'rxjs';
import { Request, Response } from '../lib/models/request-response';
import { ISettings } from '@lsq-frontend/angular-shared/settings';
import { ErrorResponse } from './models/error';
import { pascalCaseRpcInUrl } from './helpers/http.helpers';

export class GenericApiService {
    public dataSubject = new Subject<Response>();
    public errorSubject = new Subject<ErrorResponse>();
    public dataStream = this.dataSubject.asObservable();
    public errorStream = this.errorSubject.asObservable();

    constructor(private _http: HttpClient, private _settings: ISettings) {}

    public execute(endpointUrl: string, request?: Request): void {
        const baseUrl = this._settings.httpApiServiceNameUrlMap[
            this._settings.httpApiDefaultServiceName
        ];
        // Convert endpoint name to PascalCase.
        const fullUrl = pascalCaseRpcInUrl(`${baseUrl}/${trim(endpointUrl, '/')}`);
        this._http.post(fullUrl, request).subscribe(
            (data: Response) => this.dataSubject.next(data),
            (error: ErrorResponse) => this.errorSubject.next(error)
        );
    }

    public executeOnce(endpointUrl: string, request?: Request): Promise<Response> {
        const baseUrl = this._settings.httpApiServiceNameUrlMap[
            this._settings.httpApiDefaultServiceName
        ];
        // Convert endpoint name to PascalCase.
        const fullUrl = pascalCaseRpcInUrl(`${baseUrl}/${trim(endpointUrl, '/')}`);
        return this._http.post<Response>(fullUrl, request).toPromise();
    }
}

export class GenericBoundedApiService<
    TRequest extends Request = Request
> extends GenericApiService {
    public requestType: Type<Request>;
    private endpointUrl: string;

    constructor(
        http: HttpClient,
        settings: ISettings,
        endpointUrl: string,
        requestType: Type<TRequest> = null
    ) {
        super(http, settings);
        this.endpointUrl = endpointUrl;
        this.requestType = requestType;
    }

    public execute(request?: Request): void {
        super.execute(this.endpointUrl, request);
    }

    public executeOnce(request?: Request): Promise<Response> {
        return super.executeOnce(this.endpointUrl, request);
    }
}
